//物件追蹤
class Track {
  constructor() {
    this.objs      = $('.objRealty article');
    this.btns      = $('.trackBtns');
    this.objsH     = $('#objHeader');
    this.objBtn    = $('.objTrackBtn');
    this.objMore   = $('.objRealtyMore .box');
    this.asideObjs = $('aside .realty>li');
    this.cancelBtn = $('.cancelTrack');
  }
  //加入 & 取消追蹤
  status(btn, title) {
    if(btn.is('.active')){
      // alert('【 ' + title + ' 】已加入追蹤！');
      Swal.fire({
          title: '【 ' + title + ' 】已加入追蹤！',
          icon: 'success',
          confirmButtonText: '確定',
      }).then((result) => {
          if (result.isConfirmed) {
              location.reload();
          }
      });


    }else{
      // alert('【 ' + title + ' 】已移除追蹤！');
      Swal.fire({
          title: '【 ' + title + ' 】已移除追蹤！',
          icon: 'success',
          confirmButtonText: '確定',
      }).then((result) => {
          if (result.isConfirmed) {
              location.reload();
          }
      });
    }

  }
  //物件cookie加入移除追蹤 (昀寬多加
  cookieTrack(trackid) {
    $.post('ajax_objectinfo_cookie.php', {id: trackid}).done((e) => {
      // $('body').addClass('active');
      // console.log(e);
      // location.reload();
    }, 'json');
    
  }
  //列表
  toggleTrack() {
    this.objs.each((i, e) => {
      $(e).find(this.btns).on('click', (j) => {
        const $this = $(j.currentTarget);
        $this.toggleClass('active');
        this.status($this, $(e).find('h3').text());
        this.cookieTrack($this.data('trackid'));
      });
    });
  }
  //物件內頁 & 側邊攔
  toggleAsideTrack() {
    //物件內頁
    let objBtnTxt = this.objBtn.parent().find('span');
    if(this.objBtn.is('.active')){
      objBtnTxt.text('移除追蹤');
    }else{
      objBtnTxt.text('加入追蹤');
    }
    this.objBtn.on('click', () => {
      this.objBtn.toggleClass('active');
      this.cookieTrack(this.objBtn.data('trackid'));
      this.status(this.objBtn, this.objsH.find('h3').text()); ////追蹤
    });
    let itemsTrack = (el) => {
      el.each((i, e) => {
        $(e).find(this.btns).on('click', (j) => {
          const $this = $(j.currentTarget);
          $this.toggleClass('active');
          this.cookieTrack($this.data('trackid'));
          this.status($this, $(e).find('h3').text()); //追蹤
          
        });
      });
    }
    //物件內頁(其它推薦)
    itemsTrack(this.objMore);
    //文章內頁-側邊攔
    itemsTrack(this.asideObjs);
  }
  //移除追蹤(Header追蹤列表)
  cancelTrack() {
    this.cancelBtn.on('click', (e) => {
      const $this   = $(e.currentTarget);
      const objName = $this.parent().find('h3').text();
      /*
      if(confirm('移除【 ' + objName + ' 】追蹤？')){
        this.cookieTrack($this.data('trackid'));
      }else{
        return false;
      }
      */
     Swal.fire({
        title: '移除【 ' + objName + ' 】追蹤？',
        showDenyButton: true,
        confirmButtonText: '是',
        denyButtonText: `否`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.cookieTrack($this.data('trackid'));
        } else if (result.isDenied) {
          return false;
        }
      });
    });
  }
}




//輸出
export {Track};


// WEBPACK FOOTER //
// ./js_new/track.js